import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_label = _resolveComponent("bs5-base-label")!
  const _component_bs5_base_input = _resolveComponent("bs5-base-input")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!

  return (_openBlock(), _createBlock(_component_bs5_base_modal, {
    title: "Add Client",
    visible: _ctx.visible,
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addClient && _ctx.addClient(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_bs5_base_label, { for: "name" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Name")
            ])),
            _: 1
          }),
          _createVNode(_component_bs5_base_input, {
            id: "name",
            modelValue: _ctx.newClient.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newClient.name) = $event)),
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_bs5_base_label, { for: "description" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Description")
            ])),
            _: 1
          }),
          _createVNode(_component_bs5_base_input, {
            id: "description",
            modelValue: _ctx.newClient.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newClient.description) = $event))
          }, null, 8, ["modelValue"])
        ])
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, null, 8, ["onClick"]),
      _createVNode(_component_bs5_save_button, {
        loading: _ctx.saving,
        onClick: _ctx.addClient
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("Add Client")
        ])),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}